import React from 'react';
import PropTypes from 'prop-types';

const ValidationErrorMessage = ({error, testId, className = 'w-[320px]'}) => {
  if (!error) return null;

  return (
    <div
      className={`text-sm text-[color:var(--color-feedback-error-high-contrast)] ${className}`.trim()}
      data-testid={testId}>
      {error}
    </div>
  );
};

ValidationErrorMessage.propTypes = {
  error: PropTypes.string,
  testId: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default React.memo(ValidationErrorMessage);
